module.exports = __webpack_public_path__ + "img/Help.svg";


//////////////////
// WEBPACK FOOTER
// ./img/Help.svg
// module id = 252
// module chunks = 0